<template>
    <div id="facilities">
        <section class="section">
            <div class="container">
                <h2 class="section-title" v-scroll-reveal>
                    <span class="_order">04</span>
                    <span class="_title" v-html="$t('Facilities')"></span>
                </h2>

                <div class="flex flex-wrap md:items-center">
                    <div class="w-full md:w-1/3">
                        <h3 class="section-subtitle mb-lg" v-scroll-reveal>{{ $t('Type and size') }}</h3>
                    </div>

                    <div class="w-full md:w-2/5 md:ml-auto">
                        <ul class="list-features" v-scroll-reveal>
                            <li class="_item">
                                <span class="__label">{{ $t('Indoor area') }}:</span>
                                <span class="__value">228 m2</span>
                            </li>
                            <li class="_item">
                                <span class="__label">{{ $t('Total plot area') }}:</span>
                                <span class="__value">1800 m2</span>
                            </li>
                            <li class="_item">
                                <span class="__label">{{ $t('Type') }}:</span>
                                <span class="__value">{{ $t('Detached') }}</span>
                            </li>
                            <li class="_item">
                                <span class="__label">{{ $t('Max. guests') }}:</span>
                                <span class="__value">9</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-cover bg-white">
            <figure style="background-image: url(/img/5-okolis.jpg)"></figure>

            <div class="container _content">
                <h3 class="_title" v-scroll-reveal>{{ $t('Outdoors') }}</h3>

                <ul class="list-features flex flex-wrap -mx-base">
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Private pool') }}:</span>
                        <span class="__value">50 m2</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Sun loungers') }}:</span>
                        <span class="__value">8</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Garden') }}</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Completely enclosed') }}</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Private parking') }}:</span>
                        <span class="__value">{{ $t('Gated') }}</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Parking spaces') }}:</span>
                        <span class="__value">4</span>
                    </li>
                </ul>

                <ul class="list-default text-sm md:text-base xl:text-h5 mt-base md:mt-lg">
                    <li class="text-primary" v-scroll-reveal>* {{ $t('Pool towels are provided') }}</li>
                </ul>

                <button class="btn mt-lg" @click="showOutdoors()">View Gallery</button>
            </div>
        </section>

        <section class="section section-cover bg-secondary">
            <figure style="background-image: url(/img/13-soba-1.jpg)"></figure>

            <div class="container _content text-white">
                <h3 class="_title" v-scroll-reveal>Bedrooms</h3>

            <div>
                <VueEasyLightbox
                    :visible="visible"
                    :imgs="imgs"
                    :index="index"
                    @hide="handleHide">
            </VueEasyLightbox>
            </div>

                <ul class="list-features flex flex-wrap -mx-base">
                    <li class="_item _list w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label uppercase">Bedroom No. 1</span>
                        <span class="__value">
                            <span>Double beds: 1</span>
                            <span>Extra beds: 1</span>
                        </span>
                    </li>
                    <li class="_item _list w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label uppercase">Bedroom No. 2</span>
                        <span class="__value">
                            <span>Single beds: 2</span>
                        </span>
                    </li>
                    <li class="_item _list w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label uppercase">Bedroom No. 3</span>
                        <span class="__value">
                            <span>Double beds: 1</span>
                        </span>
                    </li>
                    <li class="_item _list w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label uppercase">Bedroom No. 4</span>
                        <span class="__value">
                            <span>Single beds: 2</span>
                        </span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">Baby cot:</span>
                        <span class="__value">1 </span>
                    </li>
                </ul>

                <ul class="list-default text-sm md:text-base xl:text-h5 mt-base md:mt-lg">
                    <li class="text-primary" v-scroll-reveal>* Bed linens are provided and changed once per week</li>
                    <li class="text-primary" v-scroll-reveal>* All bedrooms have A/C</li>
                    <li class="text-primary" v-scroll-reveal>* Baby cot available upon request</li>
                    <li class="text-primary" v-scroll-reveal>* The single beds can be put together or separated</li>
                    <li class="text-primary" v-scroll-reveal>* The extra bed is a pull out bed</li>
                </ul>

                <button class="btn text-white mt-lg" @click="showBedrooms()">View Gallery</button>
            </div>
        </section>

        <section class="section section-cover bg-white">
            <figure style="background-image: url(/img/18-kupaona-1.jpg)"></figure>

            <div class="container _content">
                <h3 class="_title" v-scroll-reveal>{{ $t('Bathrooms') }}</h3>

                <ul class="list-features flex flex-wrap -mx-base">
                    <li class="_item _list w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label uppercase">{{ $t('Bathroom No.') }} 1</span>
                        <span class="__value">
                            <span>{{ $t('Washbasin') }}</span>
                            <span>{{ $t('Toilet') }}</span>
                            <span>{{ $t('Bath') }}</span>
                            <span>{{ $t('Shower enclosure') }}</span>
                        </span>
                    </li>
                    <li class="_item _list w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label uppercase">{{ $t('Bathroom No.') }} 2</span>
                        <span class="__value">
                            <span>{{ $t('Washbasin') }}</span>
                            <span>{{ $t('Toilet') }}</span>
                            <span>{{ $t('Shower enclosure') }}</span>
                        </span>
                    </li>
                    <li class="_item _list w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label uppercase">{{ $t('Bathroom No.') }} 3</span>
                        <span class="__value">
                            <span>{{ $t('Washbasin') }}</span>
                            <span>{{ $t('Toilet') }}</span>
                            <span>{{ $t('Shower enclosure') }}</span>
                        </span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label uppercase">{{ $t('WC') }}:</span>
                        <span class="__value">1</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Bathroom ensuite') }}</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Outdoor shower') }}</span>
                    </li>
                </ul>

                <ul class="list-default text-sm md:text-base xl:text-h5 mt-base md:mt-lg">
                    <li class="text-primary" v-scroll-reveal>* {{ $t('Bathroom towels are available and changed once per week') }}</li>
                </ul>

                <button class="btn mt-lg" @click="showBathrooms()">View Gallery</button>
            </div>
        </section>

        <section class="section section-cover bg-secondary">
            <figure style="background-image: url(/img/5-kuhinja.jpg)"></figure>

            <div class="container _content text-white">
                <h3 class="_title" v-scroll-reveal>{{ $t('Kitchen and dining') }}</h3>

                <ul class="list-features flex flex-wrap -mx-base">
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Fully-equipped kitchen') }}</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Toaster') }}</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Coffee machine') }}</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Microwave') }}</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Fridge with freezer') }}</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Dishwasher') }}</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('BBQ - charcoal') }}</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Extra outdoor kitchen') }}</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <div class="__label">
                            <span>{{ $t('Indoor dining area for') }}:</span>
                            <span class="__value">10</span>
                        </div>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <div class="__label">
                            <span>{{ $t("Child's high chair") }}:</span>
                            <span class="__value">1</span>
                        </div>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <div class="__label">
                            <span>{{ $t('Outdoor dining area for') }}:</span>
                            <span class="__value">8</span>
                        </div>
                    </li>
                </ul>

                <ul class="list-default text-sm md:text-base xl:text-h5 mt-base md:mt-lg">
                    <li class="text-primary" v-scroll-reveal>* {{ $t('Filter coffee machine, moka, mixer, kettle' ) }}</li>
                    <li class="text-primary" v-scroll-reveal>* {{ $t("Child's high chair available upon request" ) }}</li>
                </ul>

                <button class="btn text-white mt-lg" @click="showKitchen()">View Gallery</button>
            </div>
        </section>

        <section class="section section-cover bg-white">
            <figure style="background-image: url(/img/12-dnevna-soba.jpg)"></figure>

            <div class="container _content">
                <h3 class="_title" v-scroll-reveal>{{ $t('Living room') }}</h3>

                <ul class="list-features flex flex-wrap -mx-base">
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Fireplace') }}</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('SAT TV') }}</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('TV') }}</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('DVD player') }}</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Stereo system') }}</span>
                    </li>
                    <li class="_item w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Game console') }}</span>
                    </li>
                </ul>

                <ul class="list-default text-sm md:text-base xl:text-h5 mt-base md:mt-lg">
                    <li class="text-primary" v-scroll-reveal>* {{ $t('Sony PlayStation 3') }}</li>
                </ul>

                <button class="btn mt-lg" @click="showLivingRoom()">View Gallery</button>
            </div>
        </section>

        <section class="section section-cover bg-secondary">
            <figure style="background-image: url(/img/29-okolis.jpg)"></figure>

            <div class="container _content text-white">
                <h3 class="_title" v-scroll-reveal>{{ $t('Other') }}</h3>

                <ul class="list-features flex flex-wrap -mx-base">
                    <li class="_item _list w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Activities on site') }}</span>
                        <span class="__value">
                            <span>{{ $t('Basketball') }}</span>
                            <span>{{ $t('Badminton (no net') }})</span>
                            <span>{{ $t('Mini kicker for children') }}</span>
                        </span>
                    </li>
                    <li class="_item _list w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Suitability') }}</span>
                        <span class="__value">
                            <span>{{ $t('Children') }}</span>
                        </span>
                    </li>
                    <li class="_item _list w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Cooling and heating') }}</span>
                        <span class="__value">
                            <span>{{ $t('Fully air-conditioned') }}</span>
                            <span>{{ $t('Central heating') }}</span>
                            <span>{{ $t('Underfloor heating') }}</span>
                            <span>{{ $t('Air-condition units no') }}: 7</span>
                        </span>
                    </li>
                    <li class="_item _list w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Internet') }}</span>
                        <span class="__value">
                            <span>{{ $t('Wi-Fi') }}</span>
                        </span>
                    </li>
                    <li class="_item _list w-full md:w-1/2 xl:w-1/3 px-base" v-scroll-reveal>
                        <span class="__label">{{ $t('Laundry') }}</span>
                        <span class="__value">
                            <span>{{ $t('Washing machine') }}</span>
                            <span>{{ $t('Iron and board') }}</span>
                        </span>
                    </li>
                </ul>

                <ul class="list-default text-sm md:text-base xl:text-h5 mt-base md:mt-lg">
                    <li class="text-primary" v-scroll-reveal>* {{ $t('Pets are not allowed') }}</li>
                    <li class="text-primary" v-scroll-reveal>* {{ $t('Underfloor heating in all rooms') }}</li>
                </ul>

                <button class="btn text-white mt-lg" @click="showOther()">View Gallery</button>
            </div>
        </section>
    </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
  components: {
    VueEasyLightbox
  },
  data() {
    return {
      imgs: [],  // Img Url , string or Array
      visible: false,
      index: 0   // default
    }
  },
  methods: {
    showBedrooms() {
      this.imgs = ['img/bedrooms optimizirano/1-Soba-2.jpg', 'img/bedrooms optimizirano/1-soba-4.jpg', '/img/bedrooms optimizirano/5-soba-3.jpg','/img/bedrooms optimizirano/12-soba-1.jpg']
      index: 0
      this.visible = true
    },
    showBathrooms(){
        this.imgs = ['img/bathrooms optimizirano/4-kupaona-1.jpg', 'img/bathrooms optimizirano/14-kupaona-1.jpg', '/img/bathrooms optimizirano/16-kupaona-1.jpg','/img/bathrooms optimizirano/18-kupaona-1.jpg']
        index: 0
        this.visible = true
    },
    showKitchen(){
        this.imgs = ['img/kitchen and dining optimizirano/1-kuhinja.jpg', 'img/kitchen and dining optimizirano/3-kuhinja.jpg', '/img/kitchen and dining optimizirano/4-kuhinja.jpg','/img/kitchen and dining optimizirano/5-kuhinja.jpg']
        index: 0
        this.visible = true
    },
    showLivingRoom(){
        this.imgs = ['img/living room optimizirano/6-dnevna-soba.jpg', 'img/living room optimizirano/7-dnevna-soba.jpg', '/img/living room optimizirano/11-dnevna-soba.jpg','/img/living room optimizirano/12-dnevna-soba.jpg']
        index: 0
        this.visible = true
    },
    showOther(){
        this.imgs = ['img/others optimizirano/Kabola.jpg', 'img/others optimizirano/Kanegra.jpg', '/img/others optimizirano/Kozlovic-1.jpg','/img/others optimizirano/Momjan-1.jpg']
        index: 0
        this.visible = true
    },
    showOutdoors(){
        this.imgs = ['img/outdoors optimizirano/2.jpg', 'img/outdoors optimizirano/3.jpg', '/img/outdoors optimizirano/3a.jpg','/img/outdoors optimizirano/3-bazen-2.jpg']
        index: 0
        this.visible = true
    },
    handleHide() {
      this.visible = false
    }
  }
}
</script>
